export default __webpack_public_path__ + "images/139bda4556760c67ccf8e52e9db063a8-photos.svg";